import { Typography } from "@mui/material";
import { skipToken } from "@reduxjs/toolkit/query";
import { format } from "date-fns";
import { useGetOrderForInvoiceQuery } from "src/api/services/ordersApi";

interface Props {
  invoiceId: string | null;
  attempt: "next" | "last";
}

const formatDate = (date: string | null | undefined) => {
  if (date == null) return "N/A";

  return format(new Date(date), "MM/dd/yyyy");
};

const ChargeAttemptCell = ({ invoiceId, attempt }: Props) => {
  const { data } = useGetOrderForInvoiceQuery(invoiceId ?? skipToken);

  if (attempt === "last") {
    return <Typography>{formatDate(data?.last_attempt_at)}</Typography>;
  }

  if (attempt === "next") {
    return <Typography>{formatDate(data?.next_attempt_at)}</Typography>;
  }
};

export default ChargeAttemptCell;
